enum OptionTypeEnum {
    Participant = "PARTICIPANT",
    Accomodation = "ACCOMODATION",
    Global = "GLOBAL",
}

export default OptionTypeEnum